import { isArray } from './isArray'

export function isObject<T>(o: T): boolean {
  return o === Object(o) && !isArray(o) && typeof o !== 'function'
}
